import React, { useContext, useReducer, createContext, useEffect } from 'react';
import produce from 'immer';
import { useLocation } from 'react-router-dom';

const ProfileViewStateContext = createContext();
const ProfileViewDispatchContext = createContext();

export const CONTROL_MODAL = 'CONTROL_MODAL';
export const RESET = 'RESET';

const initialState = () => ({
    modal: [],
    params: {}
});

const reducer = produce((draft, action) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
        case CONTROL_MODAL:
            draft.modal = [action.open];
            if (action.close) draft.modal = draft.modal.filter(m => m === action.close);
            draft.params = action.params
            break;
        case RESET:
            return initialState();
    }
}, {});

function ProfileViewProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState());

    const { search } = useLocation();

    useEffect(() => {
        const menu = new URLSearchParams(search);
        const saveSignature = menu.has('saveSignature');
        const isStoreOpen = menu.get('isStoreOpen');
        if (isStoreOpen) {
            dispatch({ type: 'CONTROL_MODAL', open: 'STORE' })
        } else if (saveSignature) {
            dispatch({ type: 'CONTROL_MODAL', open: 'SIGNATURE' })
        }
    }, [search])

    return (
        <ProfileViewStateContext.Provider value={{ ...state }}>
            <ProfileViewDispatchContext.Provider value={dispatch}>
                {children}
            </ProfileViewDispatchContext.Provider>
        </ProfileViewStateContext.Provider>
    )
}

function useProfileViewState() {
    const context = useContext(ProfileViewStateContext)
    if (context === undefined) {
        throw new Error('useProfileViewState must be used within a ProfileViewProvider')
    }
    return context
}

function useProfileViewDispatch() {
    const context = useContext(ProfileViewDispatchContext)
    if (context === undefined) {
        throw new Error('useProfileViewDispatch must be used within a ProfileViewProvider')
    }
    return context
}


function useProfileView() {
    return [useProfileViewState(), useProfileViewDispatch()]
}

export { ProfileViewProvider, useProfileView, useProfileViewState, useProfileViewDispatch }
